<template lang="pug">
div
  v-container.pa-0(fluid)
    div.d-flex.justify-center.mt-16(v-if="isFetching")
      v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

    template(v-else-if="stockTake")
      div.pa-4
        v-row(no-gutters align="center")
          v-col.pr-2
            div.text-xl.font-semibold.neutral700--text {{ stockTake.name }}
          v-col.shrink(v-if="stockTake.member.id === member.id")
            y-button(label="Finish counting" color="neutral700" size="sm" dark :loading="isLoading" @click="openFinishCountDialog = true")

        v-row.mt-6(dense align="center")
          v-col.pr-2
            div
              div.d-flex.align-center
                v-icon(color="neutral700" size="22") $yzi-users-solid-03
                div.text-sm.neutral700--text.ml-3 {{ stockTake.member.name }}
            div
              div.d-flex.align-center
                v-icon.mb-1(color="neutral700" size="22") $yzi-calendar-solid
                div.text-sm.neutral700--text.font-semibold.ml-3 Start date:
                div.text-sm.neutral700--text.ml-1 {{ stockTake.created | humanizeDate }}
            div
              div.d-flex.align-center
                v-icon.mb-1(color="neutral700" size="22") $yzi-clock-check-solid
                div.text-sm.neutral700--text.font-semibold.ml-3 Start time:
                div.text-sm.neutral700--text.ml-1 {{ stockTake.created | displayTime2 }}
          v-col.shrink
            y-button(label="Share" underline size="xs" button-class="px-0" prepend-icon="$yzi-upload-01" icon-size="18" icon-color="neutral700" @click="openShareDialog = true")

      div.border-custom
        v-progress-linear(v-if="isFetchingLocations" width="2" rounded color="primary" indeterminate)
        v-tabs.tabs-custom(v-model="locationTab" color="basic700" background-color="neutral200" height="44" @change="updateTab(locationTab)" )
          template(v-for="location in locations")
            v-tab.text-sm.font-normal.text-none(active-class="font-semibold") {{ location.name }}

      div.d-flex.justify-center.mt-16(v-if="isFetchingProducts")
        v-progress-circular(:width="2" :size="30" color="primary" indeterminate)
      
      template(v-else)
        template(v-for="product in products")
          div.pa-4(:key="product.id")
            v-row(no-gutters)
              v-col.pr-1(cols="6" style="word-break: break-word;")
                .text-sm.font-medium.neutral700--text {{ product.name }}
              v-col.pl-1(cols="6" align="right" style="word-break: break-word;")
                .text-sm.neutral700--text(v-if="getStockUnit(product)") {{ getStockUnit(product) }}
                .text-sm.font-medium.success500--text(v-if="product.inventory_qty") Current count: {{ product.inventory_qty }}
                .text-sm.font-medium.info500--text(v-if="checkActualCount(product)") Actual count: {{ checkActualCount(product) }}
            template(v-if="stockTake.member.id === member.id")
              template(v-if="checkStockDiff(product) === null")
                v-row.mt-2(no-gutters)
                  v-col.pr-1(cols="6")
                    y-button(label="New count" outlined size="sm" block @click="openNewCount(product)")
                  v-col.pl-1(cols="6")
                    y-button(label="Matched" outlined size="sm" block @click="matchingCount(product)")
              template(v-else)
                v-row.mt-2(no-gutters)
                  v-col.pr-1(cols="6")
                    y-button(label="Remove" color="neutral300" text-color="danger500" size="sm" block @click="openRemoveCount(product)")
                  v-col.pl-1(cols="6")
                    y-button(label="Edit" outlined size="sm" block @click="openNewCount(product)")
          v-divider

        template(v-if="!products.length")
          div.mt-10(v-if="status === 'pending'" align="center")
            img.mx-auto(:src="require('@/assets/images/stocktake_counted.png')" width="100")
            .mt-2.text-sm.font-semibold.neutral700--text Good job!
            .mt-2.text-sm.neutral700--text You’ve counted all the item

          div.mt-10.text-sm.neutral500--text.text-center(v-else) No item found

      div.d-flex.justify-center.mt-4(v-if="isFetchingMoreProducts")
        v-progress-circular(:width="2" :size="30" color="primary" indeterminate)
          
      div(align="center" v-if="next")
        v-btn.text-sm.text-none.mt-4(color="neutral300" small rounded depressed @click="fetchNext") Load more
      div.py-10

    v-bottom-navigation(fixed grow height="52")
      v-btn(@click="updateStatusFilter('all')")
        span.text-xs.font-semibold(:class="status === 'all' ? 'neutral700--text' : 'neutral500--text'") All
      v-divider(vertical)
      v-btn(@click="updateStatusFilter('pending')")
        span.text-xs.font-semibold(:class="status === 'pending' ? 'neutral700--text' : 'neutral500--text'") Pending
      v-divider(vertical)
      v-btn(@click="updateStatusFilter('counted')")
        div.d-flex.align-center
          span.text-xs.font-semibold(:class="status === 'counted' ? 'neutral700--text' : 'neutral500--text'") Counted
          v-chip.px-1.ml-1(v-if="countedCount" color="neutral500" x-small dark) {{ countedCount }}
      v-divider(vertical)
      v-btn.px-0(@click="openSearchDialog = true")
        v-icon(size="18") $yzi-search-sm
  
  .dialogs
    share-stock-take-bottom-sheet(v-if="openShareDialog" :open.sync="openShareDialog" :stocktake="stockTake")
    new-count-bottom-sheet(v-if="openNewCountSheet" :open.sync="openNewCountSheet" :product="selectedProduct" :stocktake-id="id" :prefillCount="checkActualCount(selectedProduct) || selectedProduct.inventory_qty" :changed-products.sync="changedProducts" @closed="closedDialog")
    remove-count-dialog(v-if="openRemoveCountDialog" :open.sync="openRemoveCountDialog" :product="selectedProduct" :stocktake-id="id" :changed-products.sync="changedProducts" @closed="closedDialog")
    finish-count-mobile-dialog(v-if="openFinishCountDialog" :open.sync="openFinishCountDialog" :stocktake="stockTake" :changed-products="changedProducts" @finish="saveData")
    stock-take-search-dialog(v-if="openSearchDialog" :open.sync="openSearchDialog" :stocktake-id="id" :changed-products.sync="changedProducts" @closed="closedDialog")

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ShareStockTakeBottomSheet from '@/components/clinic/inventory/stocktake/ShareStockTakeBottomSheet.vue'
import NewCountBottomSheet from '@/components/clinic/inventory/stocktake/NewCountBottomSheet.vue'
import RemoveCountDialog from '@/components/clinic/inventory/stocktake/RemoveCountDialog.vue'
import RevertCountDialog from '@/components/clinic/inventory/stocktake/RevertCountDialog.vue'
import FinishCountMobileDialog from '@/components/clinic/inventory/stocktake/FinishCountMobileDialog.vue'
import StockTakeSearchDialog from '@/components/clinic/inventory/stocktake/StockTakeSearchDialog.vue'

export default {
  components: { ShareStockTakeBottomSheet, NewCountBottomSheet, RemoveCountDialog, RevertCountDialog, FinishCountMobileDialog, StockTakeSearchDialog },
  props: ['id', 'summaryPage'],
  data () {
    return {
      isLoading: false,
      isFetching: false,
      isFetchingLocations: false,
      isFetchingProducts: false,
      isFetchingMoreProducts: false,
      isFetchingStatus: false,
      openShareDialog: false,
      openNewCountSheet: false,
      openRemoveCountDialog: false,
      openFinishCountDialog: false,
      openSearchDialog: false,
      locationTab: 0,
      countedCount: 0,
      status: 'all',
      next: null,
      selectedProduct: null,
      stockTake: null,
      products: [],
      oriProducts: [],
      changedProducts: [],
      userLocations: []
    }
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({ company: 'getCompany' }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    locations () {
      return [{ name: 'All', isDefault: true }, ...this.userLocations, { name: 'Unassigned', isUnassigned: true, isDefault: true }]
    },
  },
  mounted () {
    this.fetchStockTake()
    this.fetchLocations()
    this.fetchProducts()
  },
  methods: {
    getStockUnit (item) {
      if (item.uom_conversion_enabled && item.uom_conversions && item.uom_conversions.length) {
        return item.uom_conversions[item.uom_conversions.length - 1].convert_to || ''
      }
      return item.uom || ''
    },
    ...mapActions(['showMessage']),
    fetchStockTake () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/stock_takes/${this.id}`)
        .then(resp => {
          if (resp.data.status === 'finished') {
            this.goToStockTakeSummary()
          }
          this.stockTake = resp.data
          this.oriProducts = JSON.parse(JSON.stringify(resp.data.products))
          this.changedProducts = JSON.parse(JSON.stringify(resp.data.products))
          this.fetchStatus()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchLocations () {
      this.isFetchingLocations = true
      let params = {
        page_size: -1,
        has_active_products: true,
        ordering: 'value'
      }
      this.$axios.get(`/clinics/${this.company.slug}/inventories/locations`,  { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            let location = resp.data.results.map(m => { return { id: m.id, name: m.value } })
            this.userLocations = location
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingLocations = false
        })
    },
    fetchProducts () {
      this.isFetchingProducts = true
      let params = {
        status: 'published',
        page_size: 20,
        page: 1,
        fields: 'id,name,uom,inventory_qty,location'
      }
      if (this.locations[this.locationTab].id) {
        params.location = this.locations[this.locationTab].id
      } else if (this.locations[this.locationTab].isUnassigned) {
        params.has_location = false
      }
      if (this.status === 'pending') {
        params.exclude_ids = this.changedProducts.map(m => m.id).join()
      } else if (this.status === 'counted') {
        if (!this.changedProducts.length) {
          this.products = []
          this.next = null
          this.isFetchingProducts = false
          return
        }
        params.ids = this.changedProducts.map(m => m.id).join()
      }
      this.$axios.get(`/clinics/${this.company.slug}/inventories`, { params })
        .then(resp => {
          this.products = resp.data.results
          this.next = resp.data.next
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingProducts = false
        })
    },
    fetchNext () {
      this.isFetchingMoreProducts = true
      const url = new URL(this.next)
      const endpoint = this.next.replace(url.origin, '')
      this.$axios.get(endpoint)
        .then(resp => {
          this.products = [ ...this.products, ...resp.data.results]
          this.next = resp.data.next
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingMoreProducts = false
        })
    },
    fetchStatus () {
      if (!this.changedProducts.length) {
        this.countedCount = 0
        return
      }
      this.isFetchingStatus = true
      let params = {
        status: 'published',
        page_size: 1,
        fields: 'id'
      }
      if (this.locations[this.locationTab].id) {
        params.location = this.locations[this.locationTab].id
      } else if (this.locations[this.locationTab].isUnassigned) {
        params.has_location = false
      }
      params.ids = this.changedProducts.map(m => m.id).join()
      this.$axios.get(`/clinics/${this.company.slug}/inventories`, { params })
        .then(resp => {
          this.countedCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', 'Error fetching status'])
        })
        .finally(() => {
          this.isFetchingStatus = false
        })
    },
    updateStatusFilter (status) {
      this.status = status
      this.fetchProducts()
    },
    updateTab () {
      this.status = 'all'
      this.fetchProducts()
      this.fetchStatus()
    },
    checkActualCount (product) {
      let count = null
      let diff = this.checkStockDiff(product)
      if (diff !== null) {
        count = product.inventory_qty + diff
      }
      return count
    },
    checkStockDiff (product) {
      let quantity = null
      let findProduct = this.changedProducts.find(f => f.id === product.id)
      if (findProduct){
        quantity = findProduct.change
      }
      return quantity
    },
    openNewCount (product) {
      this.selectedProduct = product
      this.openNewCountSheet = true
    },
    openRemoveCount (product) {
      this.selectedProduct = product
      this.openRemoveCountDialog = true
    },
    matchingCount (item) {
      this.isLoading = true
      let products = [...this.changedProducts]
      products = products.filter(f => f.id !== item.id)
      products.push({ id: item.id, change: 0 })
      this.$axios.patch(`/clinics/${this.company.slug}/stock_takes/${this.stockTake.id}`, { products: products })
        .then(() => {
          this.changedProducts = [...products]
          this.fetchStatus()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveData () {
      this.isLoading = true
      let data = { status: 'finished' }
      const endpoint = `/clinics/${this.company.slug}/stock_takes/${this.id}`
      this.$axios.patch(endpoint, data)
        .then(resp => {
          let activity = `Finishing ${resp.data.name}`
          this.updateActivityLog(endpoint, data, resp, 'PATCH', activity, this.id )
          this.showMessage(['success', `${resp.data.name} finished`])
          this.goToStockTakeSummary()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closedDialog () {
      this.selectedProduct = null
      this.fetchStatus()
    },
    goToStockTakeSummary () {
      let params = { id: this.id }
      this.$router.push({ name: this.summaryPage, params })
    },
    updateActivityLog (endpoint, payload, response, method, activity, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'stocktake',
        activity: activity,
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .autocmplt {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
  .tabs-custom {
    .v-slide-group__prev {
      display: none !important;
    }
    .v-slide-group__next {
      display: none !important;
    }
  }
  .v-item-group.v-bottom-navigation {
    .v-btn {
      max-width: unset;
      min-width: unset;
    }
  }
}
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
.button-box {
  border-left: solid 1px var(--v-neutral400);
  border-top: solid 1px var(--v-neutral400);
  border-bottom: solid 1px var(--v-neutral400);
  border-radius: 10px 0 0 10px;
  background-color: var(--v-neutral200);
}
.border-custom {
  border-top: solid 1px var(--v-neutral300);
  border-bottom: solid 1px var(--v-neutral300);
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>